import React, { useEffect, useRef } from "react";
import { Label, Input, FormGroup, Button, Card } from "reactstrap";
import HomeHyperlinks from "./home-hyperlinks";

import HomeHyperlinksSelect from "./home-qa-linear-select";

// Backend placeholder for an unanswered free-text question - never show it as real answer content
const FREE_FORM_PLACEHOLDER = "Free-form Response";
const getFreeTextAnswer = (answer) => (answer && answer !== FREE_FORM_PLACEHOLDER ? answer : "");

export default function HomeQAL(props) {
    const hyperlinkRef = useRef(null);
    const [charCounts, setCharCounts] = React.useState({});
    useEffect(() => {
        // allQ is nulled out on every reset/new problem selection (clearQuestionAnswer) - clear stale per-question counts with it
        if (!props.allQ) {
            setCharCounts({});
        }
    }, [props.allQ]);



    return (
        <>


            {props.allQ && props.allQ.length > 0 ? (
                <div>
                    {props.allQ.map((q) => (
                        <Card className="QALCard" key={"card" + q.QuestionId}>
                            <FormGroup key={q.QuestionId}>
                                <Label className="LbBold"> {props.translate(props.lang, "Question")} {q.QuestionSequence}:</Label>{" "}
                                <p>  <span disabled className="textarea" id="question" role="textbox" >{q.Question}</span></p>

                                {q.answers ? (

                                    <FormGroup>
                                        <Label className="LbBold">{props.translate(props.lang, "Answer")} {q.QuestionSequence}:</Label>
                                        {q && q.answers && q.answers[0] && q.answers[0].AnswerFormat && q.answers[0].AnswerFormat !== "FREETEXT" &&
                                            q.answers[0].AnswerFormat !== "DATE" &&

                                            q.answers ? (

                                            <HomeHyperlinksSelect q={q}
                                                id={q.QuestionId}></HomeHyperlinksSelect>
                                        ) : (
                                            ""
                                        )}

{(q && q.answers && q.answers[0] && q.answers[0].AnswerFormat && q.answers[0].AnswerFormat === "FREETEXT") && q.answers ? (
    <div>
        <div style={{ position: 'relative' }}>
            <span className="textareaEdit form-control" id="question" role="textbox" contentEditable autoComplete="on"
                id={q.answers[0].AnswerId}
                name={q.answers[0].AnswerId}
                key={q.answers[0].AnswerId}
                style={{ paddingRight: '70px', minHeight: '38px', display: 'block' }}
                ref={(el) => {
                    // key={AnswerId} forces a fresh DOM node per answer, so this only runs on mount, not on every re-render - keep the visible text in sync with the actual answer/counter
                    const initialText = getFreeTextAnswer(q.answers[0].Answer);
                    if (el && el.textContent !== initialText) {
                        el.textContent = initialText;
                        el.classList.toggle("is-valid", !!initialText);
                        el.classList.toggle("form-control", !!initialText);
                    }
                }}
                onKeyDown={(e) => {
                    if (e.key.length === 1 && !e.ctrlKey && !e.metaKey &&
                        e.currentTarget.textContent.length >= 50) {
                        e.preventDefault();
                    }
                }}
                onPaste={(e) => {
                    e.preventDefault();
                    const remaining = 50 - e.currentTarget.textContent.length;
                    if (remaining <= 0) return;
                    const text = (e.clipboardData || window.clipboardData).getData('text/plain');
                    document.execCommand('insertText', false, text.substring(0, remaining));
                }}
                onInput={(e) => {
                    const text = e.currentTarget.textContent;
                    setCharCounts((prev) => ({ ...prev, [q.QuestionId]: text.length }));

                    if (e.currentTarget.textContent && e.currentTarget.textContent.length > 0) {
                        e.currentTarget.classList.add("is-valid");
                        e.currentTarget.classList.add("form-control");
                    } else {
                        e.currentTarget.classList.remove("is-valid");
                        e.currentTarget.classList.remove("form-control");
                    }
                    q.answers[0].Answer = e.currentTarget.textContent;
                    q.AnswerValue = e.currentTarget.textContent;
                }} >
            </span>
            <div style={{ 
                position: 'absolute', 
                right: '27px', 
                top: '50%', 
                transform: 'translateY(-50%)', 
                fontSize: '0.875rem', 
                color: '#6c757d',
                pointerEvents: 'none',
                userSelect: 'none'
            }}>
                {charCounts[q.QuestionId] !== undefined ? charCounts[q.QuestionId] : getFreeTextAnswer(q.answers[0].Answer).length} / 50
            </div>
        </div>
                                                {/* <span className="qa-label" id={"tellcaller" + q.QuestionId}>{q.TellCaller}</span> */}
                                                <HomeHyperlinks tellCaller={q.TellCaller} id={"tellcaller" + q.QuestionId}></HomeHyperlinks>


                                            </div>



                                        ) : (
                                            ""
                                        )}

                                        {q && q.answers && q.answers[0] && q.answers[0].AnswerFormat && q.answers[0].AnswerFormat === "DATE" && q.answers ? (

                                            <div>
                                                <Input className="LbBold"
                                                    type="date"
                                                    name="date"
                                                    id={q.answers[0].AnswerId}

                                                    placeholder=""
                                                    onChange={(e) => {
                                                        let val = e.target.value.toString();
                                                        q.answers[0].Answer = val;
                                                        q.AnswerValue = val;

                                                        if (val && val.toLowerCase() != "date") {
                                                            e.currentTarget.classList.add("is-valid");
                                                            e.currentTarget.classList.add("form-control");
                                                        } else {
                                                            e.currentTarget.classList.remove("is-valid");
                                                            e.currentTarget.classList.remove("form-control");
                                                        }


                                                    }}
                                                />
                                                {/* <span className="qa-label" id={"tellcaller" + q.QuestionId}>{q.TellCaller}</span> */}
                                                <HomeHyperlinks tellCaller={q.TellCaller} id={"tellcaller" + q.QuestionId}></HomeHyperlinks>
                                            </div>
                                        ) : (
                                            ""
                                        )}
                                    </FormGroup>











                                ) : (
                                    ""
                                )}


                            </FormGroup>
                        </Card>

                    ))}

                </div>


            ) : ("")}




        </>
    );
}
